interface FaqItem {
  id: string;
  question: string;
  answer: string;
}

export const faqItems: FaqItem[] = [
  {
    id: "add-team-member",
    question: "How do I add a new team member?",
    answer:
      "Navigate to the'Team' section in the sidebar, and click on 'Add Team Member'. En email will be sent to the provided email adress, containing a link to activate their account.",
  },
  {
    id: "dashboard-update",
    question: "How often is the dashboard data updated?",
    answer:
      "The dashboard data is re-fetched every time you refresh the page.",
  },
  {
    id: "roles",
    question: "What does it mean to be an admin?",
    answer:
      "Admin users can add and edit other team members, wheres members cannot.",
  },
  {
    id: "marketplace-impressions",
    question: "What are marketplace impressions?",
    answer:
      "Marketplace impressions are the number of times a product has been viewed on the marketplace.",
  },
];
